import { createApiClient, getIntelligenceApiBaseUrl } from "./apiClientFactory";

const intelligenceApi = createApiClient({
	getBaseURL: getIntelligenceApiBaseUrl,
	service: "intelligence"
});

export default intelligenceApi;
export { getIntelligenceApiBaseUrl };
